import React from 'react';
import PropTypes from 'prop-types';
import { InboxMessagePanel } from './InboxMessagePanel';
import { InboxMessageTextArea } from './InboxMessageTextarea';
import _ from 'lodash';
import { Responsiveness } from '../elements-responsiveness/responsiveness';
import { Helpers } from 'shared-components/helpers/helpers';
import { injectIntl } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import { StreamMaintenanceBanner } from '../elements-stream/stream-chat/stream-banners/stream-maintenance-banner';

class MessageContainer extends React.Component {
  constructor (props) {
    super(props);

    this.messagesContainerRef = React.createRef();
    this.scrollBottom = this.scrollBottom.bind(this);
    this.displayResponsiveness = this.displayResponsiveness.bind(this);
    this.renderTextArea = this.renderTextArea.bind(this);
  }

  componentDidMount () {
    // Load all messages when component mounts
    if (this.props.getFullMessage) {
      this.props.getFullMessage();
    }
    setTimeout(() => {
      this.scrollBottom();
    }, 200);
  }

  componentDidUpdate (prevProps) {
    // Scroll to bottom when new messages arrive
    if (prevProps.messages.length !== this.props.messages.length) {
      this.scrollBottom();
    }
  }

  scrollBottom () {
    if (this.messagesContainerRef.current) {
      this.messagesContainerRef.current.scrollTop = this.messagesContainerRef.current.scrollHeight;
    }
  }

  displayResponsiveness () {
    const {
      responsiveness,
      display_responsiveness
    } = this.props;

    const level = _.get(responsiveness, 'level', 1);
    const bucket = _.get(responsiveness, 'bucket', '');

    const isMobile = Helpers.isMobile();
    const placement = isMobile ? 'top' : 'bottom';
    const tooltipPlacement = isMobile ? {
      top: 10,
      left: -4
    } : {
      top: -10,
      left: -5
    };

    return (
      <div className="bookings-inbox-responsiveness">
        {display_responsiveness && bucket ?
          <Responsiveness
            placement={placement}
            bucket={bucket}
            level={level}
            tooltipPlacement={tooltipPlacement}
          /> : ''
        }
      </div>
    );
  }

  renderTextArea () {
    const {
      textArea,
      messages,
      obj_state,
      streamChannelId
    } = this.props;
    const displayMessages = messages.length ? true : 'NO_AUTH' === obj_state;

    if (!displayMessages) {
      return null;
    }
    if (streamChannelId) {
      return <StreamMaintenanceBanner />;
    }
    return (
      <InboxMessageTextArea
        {...textArea}
        displayResponsiveness={this.displayResponsiveness}
      />
    );
  }

  render () {
    const {
      messages,
    } = this.props;
    return (
      <SharedIntlProviderHOC>
        <div className="message-panel-container">
          <div className="messages-wrapper" ref={this.messagesContainerRef}>
            {messages.map((msg, i) => {
              return (
                <InboxMessagePanel key={i} {...msg} />
              );
            })}
          </div>
          <div className="responsiveness-message">
            {this.renderTextArea()}
          </div>
        </div>
      </SharedIntlProviderHOC>
    );
  }
}

MessageContainer.propTypes = {
  messages: PropTypes.array,
  textArea: PropTypes.object,
  messageCount: PropTypes.number,
  getFullMessage: PropTypes.func,
  spinner: PropTypes.bool,
  totalMsgs: PropTypes.number,
  responsiveness: PropTypes.object,
  display_responsiveness: PropTypes.bool,
  listing: PropTypes.object
};

exports.MessageContainer = injectIntl(MessageContainer);
